import i18next from 'i18next';
import { DateTime } from 'luxon';
import { getShiftStartTimeAndEndTime } from 'pages/CreateShiftsPage/CreateShiftsPage.utils';

export const prettyShiftTime = (
  startDate: string,
  startAt: string,
  endAt: string,
  locale: string,
  is24hTimeFormat?: boolean,
): string => {
  const [startTime, endTime] = getShiftStartTimeAndEndTime({
    startAt,
    endAt,
  });

  const startDateTime = DateTime.fromISO(startDate);

  const dayName = startDateTime.toFormat('EEE');
  const translatedDayName = i18next.t(`translations:${dayName.toUpperCase()}`);

  const monthName = startDateTime.toFormat('MMM');
  const translatedMonthName = i18next.t(`translations:${monthName.toUpperCase()}`);

  const timeFormat = is24hTimeFormat ? 'HH:mm' : 'h:mm a';
  const startStr = DateTime.fromISO(startTime).setLocale(locale).toFormat(timeFormat);
  const endStr = DateTime.fromISO(endTime).setLocale(locale).toFormat(timeFormat);

  const normalizedStartStr = is24hTimeFormat ? startStr : startStr.toLowerCase();
  const normalizedEndStr = is24hTimeFormat ? endStr : endStr.toLowerCase();

  return `${translatedDayName}, ${translatedMonthName} ${startDateTime.toFormat(
    'dd',
  )} • ${normalizedStartStr} - ${normalizedEndStr}`;
};
